import { useTheme } from 'styled-components';
import { AppTheme } from '@/themes/types';

type ColorKey = keyof AppTheme['colors'];

export function useThemeClass() {
  const theme = useTheme() as AppTheme;

  const toHex = (color: string | undefined, fallback?: string) => color ?? (fallback ?? '#000000');

  return {
    text: (key: ColorKey = 'primary') => `text-[${toHex(theme.colors[key])}]`,
    bg: (key: ColorKey = 'primary') => `bg-[${toHex(theme.colors[key])}]`,
    border: (key: ColorKey = 'primary') => `border-[${toHex(theme.colors[key])}]`,
    border2: (key: ColorKey = 'primary') => `border-${toHex(theme.colors[key])}`,
    hoverBg: (key: ColorKey = 'primary') => `hover:bg-[${toHex(theme.colors[key])}]`,
    hoverText: (key: ColorKey = 'primary') => `hover:text-[${toHex(theme.colors[key])}]`,
    outline: (key: ColorKey = 'primary') => `outline-[${toHex(theme.colors[key])}]`,
    bgNohex:(key: ColorKey = 'primary') => `bg-${toHex(theme.colors[key])}`,
    text2: (key: ColorKey = 'primary', fallback?: string) => `text-${toHex(theme.colors[key], fallback)}`,
  };
}
